import React from 'react';

import * as Location from 'expo-location';
import { useIntl } from 'react-intl';
import { Linking } from 'react-native';

import Modal, { ModalContent } from 'components/modal';
import { StaticImage, StaticImages } from 'components/picture/static-image';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { primitive } from 'styles/constants/primitives';

import { Content, Inner, StyledActionButton, StyledDismissButton, Title } from './styled';

interface ILocationPermissionsModalProps {
  onDismiss: () => void;
  modalAppearanceEventMessage?: string;
}

export const LocationPermissionsModal: React.FC<React.PropsWithChildren<
  ILocationPermissionsModalProps
>> = ({ onDismiss, modalAppearanceEventMessage = 'Location Permissions Modal' }) => {
  const { formatMessage } = useIntl();
  const isDesktopWeb = useIsDesktopWebBreakpoint();

  const onShare = async () => {
    // Ask for permissions
    const { canAskAgain, granted } = await Location.requestForegroundPermissionsAsync();
    // Open settings to enable permissions
    if (!canAskAgain) {
      await Linking.openSettings();
    }
    // Check if permissions were granted
    if (granted) {
      onDismiss();
    }
  };

  return (
    <Modal
      isFullHeightContent
      backgroundColor={primitive.$white}
      allowsDismiss={false}
      onDismiss={onDismiss}
      amplitudeEventData={{
        modalAppearanceEventMessage,
      }}
      {...(isDesktopWeb && {
        contentStyle: { margin: '20px', maxWidth: '800px' },
      })}
    >
      <StaticImage
        alt="Man handing a Burger King meal to a guest"
        objectFitContain={false}
        source={StaticImages.LocationPermissions}
        height="460px"
        width="full"
      />
      <ModalContent>
        <Inner>
          <Title>{formatMessage({ id: 'locationPermissionTitle' })}</Title>
          <Content>{formatMessage({ id: 'locationPermissionContent' })}</Content>
          <StyledActionButton onPress={onShare}>
            {formatMessage({ id: 'locationPermissionActionButton' })}
          </StyledActionButton>
          <StyledDismissButton onPress={onDismiss}>
            {formatMessage({ id: 'locationPermissionDismissButton' })}
          </StyledDismissButton>
        </Inner>
      </ModalContent>
    </Modal>
  );
};
